import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'clients',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'clients-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                    
                    {                           
                        transKey: 'breadcrumbs.clients-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "clients-index" */ '@/modules/clients/views/Index.vue')
        },
        {
            path: 'create',
            name: 'clients-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'clients-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.clients-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.clients-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "clients-create" */ '@/modules/clients/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'clients-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'clients-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.clients-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.clients-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "clients-edit" */ '@/modules/clients/views/Edit.vue')
        }
    ]
}